import React from 'react'

const NiDebit = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4184 15.7208C11.263 16.671 12.7452 16.6787 13.5996 15.7373L14.1809 15.0967C15.3709 13.7856 16.1802 12.1743 16.5214 10.4369V10.4369C16.784 9.09961 15.896 7.80783 14.5534 7.57412L14.3406 7.53709C12.7917 7.26748 11.2079 7.26749 9.65905 7.53711L9.44188 7.57492C8.10326 7.80794 7.21959 9.09811 7.48602 10.4305V10.4305C7.8225 12.1131 8.60069 13.676 9.74072 14.9585L10.4184 15.7208Z" stroke="currentColor" stroke-width="1.75"></path></svg>
    )
}

export default NiDebit
